import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HomeService } from '../shared/services/home.service';
import { StudySurveyService } from './study-survey.service';
import { SurveyDialogBoxComponent } from './survey-dialog-box/survey-dialog-box.component';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';

@Component({
  selector: "app-study-survey",
  templateUrl: "./study-survey.component.html",
  styleUrls: ["./study-survey.component.scss"],
})
export class StudySurveyComponent implements OnInit, OnDestroy {
  public isLandscapeMode: boolean = false;
  public isDesktopView: boolean = false;
  public isSurveyLoaded: boolean = false;
  public isMobile: boolean = false;
  public trustedSurveyUrl: SafeResourceUrl = null;
  private lastSurveyUrl: string = '';
  constructor(
    public sidePanelService :SidePanelService,
    public studyService: StudySurveyService,
    private dialog: MatDialog,
    private homeService: HomeService,
    public domSanitizer:DomSanitizer,
  ) {}
  ngOnInit(): void {
    //google Analytics Subscription
    if(!this.studyService.isGoogleAnalyticsSubscribed) {
      this.studyService.isGoogleAnalyticsSubscribed = true;
      this.homeService.guestLoginClickEvent.subscribe(() => {
        this.studyService.sendSurveyGAEvent("EagleInsights-guest-login",{event_action: "Guest User Login Clicked"});
      })
    }

    this.isMobile = this.homeService.isMobileDevice();
    if(this.studyService.isSurveyReattempted) {
      
      Object.entries(this.studyService.prevState).forEach(([key,value]) => {
        if(this.hasOwnProperty(key)) {
          this[key] = value;
          delete this.studyService.prevState[key];
        }
      })
      this.studyService.sendSurveyGAEvent("EagleInsights-survey-preview-re-attempt",{});
      this.studyService.initReAttemptSurvey();
    } else {
      this.studyService.initNewSurvey();
    }
    this.studyService.isSurveyReattempted = false;
    this.studyService.accessRoles = localStorage.getItem('access') && JSON.parse(localStorage.getItem('access')) || {};
    // this.hideSideNav(false);
  }


  


  hideSideNav(show){
    setTimeout(() =>{
      if(!this.isMobile){
        let sideNav = document.getElementById('sidenav2');
        let navaction = document.getElementById('navCollapseExpandAction');
        if(navaction &&  sideNav && !show){
          sideNav.style.display = 'none';
          navaction.style.display = 'none';
        }else{
          sideNav.style.display = 'block';
          navaction.style.display = 'block';
        }
      }
    })
  }

  iframeLoaded() {
    this.isSurveyLoaded = true;
  }

  reAttemptSurvey() {
    this.studyService.isSurveyReattempted = true;
    this.studyService.prevState.isLandscapeMode = this.isLandscapeMode;
    this.studyService.prevState.isDesktopView = this.isDesktopView;
    this.studyService.reloadCurrentPage();
  }

  shareSurvey() {
    let dialogData = this.getDialogData('share');
    this.openDialogBox(dialogData);
  }

  getPreviewOnPhone() {
    let dialogData = this.getDialogData('mobile-preview');
    this.openDialogBox(dialogData);
  }

  getDialogData(type: string) {
    let dataObj = {};
    dataObj['data'] = {};
    dataObj['data']['type'] = type;
    dataObj['position'] = {};
    dataObj['position']['top'] = '15%';
    dataObj['position']['left'] = '33%';
    if(type == 'share') {
      dataObj['width'] = '600px';
      dataObj['height'] = '245px';
    } else if(type == 'mobile-preview') {
      dataObj['width'] = '600px';
      dataObj['height'] = '340px';
    }
    return dataObj;
  }

  openDialogBox(dialogData:any) {
    this.studyService.matDialogRef = this.dialog.open(SurveyDialogBoxComponent, {
      width: dialogData.width,
      height: dialogData.height,
      panelClass: 'popup-login-container',
      backdropClass: 'survey-preview-backdrop',
      position: dialogData.position,
      data: dialogData.data,
      disableClose: true
    })
  }

  rotateScreen() {
    let action = this.isLandscapeMode ? "Landscape Mode" : "Portrait Mode";
    this.studyService.sendSurveyGAEvent("EagleInsights-survey-preview-rotate-screen",{event_action: action});
  }
  
  changeDevice() {
    let action = this.isDesktopView ? "Desktop Mode" : "Mobile Mode";
    this.studyService.sendSurveyGAEvent("EagleInsights-survey-preview-toggle-device",{event_action: action});
  }

  ngOnDestroy(): void {
    this.studyService.unsetData();
    this.sidePanelService.isSurveyPreviewFromResearch = false;
    // this.hideSideNav(true);
  }

  getTrustedUrl(): SafeResourceUrl {
    // Only create new SafeResourceUrl if URL has changed
    if (this.studyService.survey_url && this.studyService.survey_url !== this.lastSurveyUrl) {
      this.lastSurveyUrl = this.studyService.survey_url;
      this.trustedSurveyUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.studyService.survey_url);
      // console.log("trusted url", this.trustedSurveyUrl);
    }
    return this.trustedSurveyUrl;
  }
}
